import { weeksInYear } from "components/pages/Chart/utils/weeksInYear";

export const unitOffsetMonths = (touchedYears: number[], index: number) => {
  if (index < 0) return 0;
  return touchedYears.slice(0, index).reduce((acc: number, year: number) => acc + weeksInYear(year), 0);
};
